export const letterSpacing = '0.05rem';
